// extracted by mini-css-extract-plugin
module.exports = {"list":"SearchCollectionResults_list__3mLPv","label":"SearchCollectionResults_label__3SIP9"};